import {
    Component,
    ElementRef,
    EventEmitter,
    Input,
    OnInit,
    Output,
    ViewChild,
    OnDestroy,
} from "@angular/core";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { fuseAnimations } from "@fuse/animations";
import { fromEvent, Subject } from "rxjs";
import { debounceTime, distinctUntilChanged, takeUntil } from "rxjs/operators";

@Component({
    selector: "app-representantes",
    templateUrl: "./representantes.component.html",
    styleUrls: ["./representantes.component.scss"],
    animations: fuseAnimations,
})
export class RepresentantesComponent implements OnInit, OnDestroy {
    @Input() representantes: any[];
    @Input() idCliente: number;
    @Output() borrarRepresentante: EventEmitter<any> = new EventEmitter();
    @Output() editarRepresentante: EventEmitter<any> = new EventEmitter();

    dataSource: MatTableDataSource<any>;
    displayedColumns = ["nombre", "apellido", "rut", "borrar"];

    @ViewChild(MatPaginator, { static: true })
    paginator: MatPaginator;

    @ViewChild(MatSort, { static: true })
    sort: MatSort;

    @ViewChild("filter", { static: true })
    filter: ElementRef;

    private _unsubscribeAll: Subject<any>;

    constructor() {
        this._unsubscribeAll = new Subject();
    }

    ngOnInit(): void {
        this.dataSource = new MatTableDataSource(this.representantes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;

        fromEvent(this.filter.nativeElement, "keyup")
            .pipe(
                takeUntil(this._unsubscribeAll),
                debounceTime(150),
                distinctUntilChanged()
            )
            .subscribe(() => {
                if (!this.dataSource) {
                    return;
                }

                this.dataSource.filter = this.filter.nativeElement.value;
            });
    }

    borrar(nrRut: number): void {
        this.borrarRepresentante.emit({
            nrRut: nrRut,
            idCliente: this.idCliente,
        });
    }

    editar(cliente) {
        this.editarRepresentante.emit(cliente);
    }

    ngOnDestroy() {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
